import { productCardStyles } from "@WhiteCap/Overrides/Widgets/ProductList/ProductListProductCard";
import { css } from "styled-components";
// EC-617 : Fixing css issues on PLP & PDP
productCardStyles.wrapper = {
    css: css`
        font-family: inherit !important;
        box-sizing: border-box;
        font-size: 12px;
        font-weight: 400;
        background-color: #f7f8f9;
        border-top: 1px solid #cccccc;
        margin: 10px 10px;
        padding-top: 5px !important;
        padding: 10px;
    `,
};
